import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Berhasil masuk");
      navigate("/");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F4F5F7] relative overflow-hidden">
      <div className="absolute -top-40 -left-40 h-[28rem] w-[28rem] rounded-full bg-indigo-300/30 blur-3xl" />
      <div className="absolute -bottom-48 -right-40 h-[28rem] w-[28rem] rounded-full bg-emerald-200/40 blur-3xl" />
      <div className="absolute top-1/4 right-1/4 h-64 w-64 rounded-full bg-sky-200/40 blur-3xl" />

      <form onSubmit={submit} className="relative w-full max-w-sm bg-white/90 backdrop-blur-xl rounded-[24px] border border-white shadow-[0_24px_60px_-16px_rgba(15,23,42,0.18)] p-8 space-y-5" data-testid="login-form">
        <div className="flex items-center gap-2.5">
          <img src="/logo-meranggi.png" alt="Meranggi Garment" className="h-12 w-12 rounded-full object-cover shadow-md shadow-slate-900/15" data-testid="login-logo" />
          <div>
            <div className="font-extrabold text-slate-900 tracking-tight">Meranggi Garment</div>
            <div className="text-[11px] text-slate-400 font-medium">CV. Meranggi Jaya</div>
          </div>
        </div>
        <div>
          <h1 className="text-2xl font-extrabold text-slate-900 tracking-tight">Masuk</h1>
          <p className="text-sm text-slate-500 mt-1">Masukkan akun Owner atau Staf Anda</p>
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" placeholder="nama@contoh.com" className="rounded-full px-4" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Kata Sandi</Label>
          <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" placeholder="••••••••" className="rounded-full px-4" />
        </div>
        <Button type="submit" className="w-full h-11 text-[15px] shadow-md" disabled={loading} data-testid="login-submit-button">
          {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Masuk
        </Button>
        <div className="text-xs text-slate-400 text-center leading-relaxed">
          CV. Meranggi Jaya · Sistem Utang Kain
        </div>
      </form>
    </div>
  );
}
